import type { PieceCategory } from '../../convex/types';

/** Label for one piece — table cells, the piece-type picker. */
export const PIECE_CATEGORY_LABEL: Record<PieceCategory, string> = {
  song: 'Song',
  exercise: 'Exercise',
  lesson: 'Lesson',
};

/** Label for a group of pieces — filters, category cards, group headings. */
export const PIECE_CATEGORY_LABEL_PLURAL: Record<PieceCategory, string> = {
  song: 'Songs',
  exercise: 'Exercises',
  lesson: 'Lessons',
};

/** Every category, in the order the pickers and filters list them. */
export const PIECE_CATEGORIES = Object.keys(PIECE_CATEGORY_LABEL) as PieceCategory[];
